import { render, staticRenderFns } from "./messages_form.vue?vue&type=template&id=12bc9791&scoped=true&"
import script from "./messages_form.vue?vue&type=script&lang=js&"
export * from "./messages_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc9791",
  null
  
)

export default component.exports